// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"ed7b8ba4","289":"1f29bcf7","787":"5ca4bde4","881":"dbb82a09"}[chunkId] + ".chunk.js";
};